import { render, staticRenderFns } from "./LayoutLms.vue?vue&type=template&id=60074cc8&scoped=true&lang=pug"
import script from "./LayoutLms.vue?vue&type=script&lang=js"
export * from "./LayoutLms.vue?vue&type=script&lang=js"
import style0 from "./LayoutLms.vue?vue&type=style&index=0&id=60074cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60074cc8",
  null
  
)

export default component.exports